<div class="form-title-container" style="margin-top: 40px;">
  <h3>Socios</h3>
  <a class="button add-button" (click)="store.openSocioModal()">Añadir socio</a>
</div>

<div class="card" style="margin-bottom: 1rem; overflow-x: auto;">
  <table class="table is-fullwidth socios-titulo-table">
    <thead>
      <tr>
        <th>Nombre</th>
        <th>NIF</th>
        <th class="numeric-cell">Nº Acciones</th>
        <th>Título</th>
        <th class="numeric-cell">Nº Acc. Ajustado</th>
        <th class="numeric-cell">Total Acc. Ajustado</th>
        <th class="numeric-cell">VN</th>
        <th class="numeric-cell">% Participación</th>
        <th class="center-cell">Presidente</th>
        <th class="center-cell">Secretario</th>
        <th class="center-cell">Socio Trabajador</th>
        <th class="icon-cell">Acciones</th>
      </tr>
    </thead>
    <tbody (mouseleave)="onSociosTableBodyLeave()">
      @for (row of sociosTituloRows(); track row.socioIndex + '_' + row.titulo) {
        <tr
          class="socios-titulo-row"
          [class.socios-titulo-row-hovered]="hoveredSocioIndex() === row.socioIndex"
          style="cursor: pointer;"
          (mouseenter)="onSocioRowEnter(row.socioIndex)"
          (click)="store.openSocioModal(row.socioIndex)"
        >
          @if (row.isFirst) {
            <td [attr.rowspan]="row.rowCount" style="vertical-align: middle;">{{ row.name }}</td>
            <td [attr.rowspan]="row.rowCount" style="vertical-align: middle;">{{ row.documentNumber }}</td>
            <td [attr.rowspan]="row.rowCount" class="numeric-cell" style="vertical-align: middle;">{{ formatShareAmount(row.sharesCountNonUsuf) }}</td>
          }
          <td>{{ row.tituloLabel }}</td>
          <td class="numeric-cell">
            {{  formatAdjusted(row.sharesCountAdjustedForTitulo) }}
          </td>
          @if (row.isFirst) {
            <td [attr.rowspan]="row.rowCount" class="numeric-cell" style="vertical-align: middle;">
              <strong>{{ formatAdjusted(row.totalAdjusted) }}</strong>
            </td>
            <td [attr.rowspan]="row.rowCount" class="numeric-cell" style="vertical-align: middle;">{{ formatEuro(row.totalVn) }}</td>
            <td [attr.rowspan]="row.rowCount" class="numeric-cell" style="vertical-align: middle;">{{ row.participationPercent }}</td>
            <td [attr.rowspan]="row.rowCount" class="center-cell" style="vertical-align: middle;">{{ row.isPresident ? '✓' : '' }}</td>
            <td [attr.rowspan]="row.rowCount" class="center-cell" style="vertical-align: middle;">{{ row.isSecretary ? '✓' : '' }}</td>
            <td [attr.rowspan]="row.rowCount" class="center-cell" style="vertical-align: middle;">{{ row.isWorker ? '✓' : '' }}</td>
            <td [attr.rowspan]="row.rowCount" class="icon-cell" style="vertical-align: middle;" (click)="$event.stopPropagation()">
              <div class="table-action-buttons">
                <a class="reopen-button" (click)="goToSocioDetail(row.socioIndex)" title="Ir al detalle">
                  <fa-icon [icon]="faUser"></fa-icon>
                </a>
                <a class="close-button" (click)="deleteSocio(row.socioIndex)" title="Eliminar" aria-label="Eliminar socio">
                  <fa-icon [icon]="faTrash"></fa-icon>
                </a>
              </div>
            </td>
          }
        </tr>
      } @empty {
        <tr>
          <td colspan="12" class="empty-row" style="text-align: center;">No hay datos</td>
        </tr>
      }
    </tbody>
  </table>
</div>

@if (store.socios().length > 0) {
  <div class="socios-summary" style="margin-bottom: 3rem;">
    <span>Nº acciones totales socios: <strong>{{ formatModalTotalAccionesAjustadas(totalSociosShares()) }}</strong></span>
    <span style="margin-left: 1.5rem;">Total acciones empresa: <strong>{{ formatShareAmount(capital.totalCompanyShares()) }}</strong></span>
  </div>
}

<div class="modal" [ngClass]="{ 'is-active': store.isSocioModalVisible() }">
  <div class="modal-background" (click)="store.closeSocioModal()"></div>
  <div class="modal-card wider-modal">
    <header class="modal-card-head">
      <p class="modal-card-title">
        {{ store.editingSocioIndex !== undefined ? 'Editar socio' : 'Nuevo socio' }}
      </p>
      <button
        class="delete"
        aria-label="close"
        (click)="store.closeSocioModal()"
      ></button>
    </header>
    <form [formGroup]="store.socioForm" (submit)="saveSocio()">
      <section class="modal-card-body">
        <div class="columns is-multiline">
          <div class="column is-6 form-container">
            <span class="label">Cliente</span>
            <p-dropdown
              [options]="store.clients()"
              optionLabel="name"
              optionValue="id"
              [filter]="true"
              filterBy="name"
              placeholder="Buscar cliente"
              formControlName="associatedClientId"
              [emptyFilterMessage]="'No se encontraron resultados'"
              appendTo="body"
            >
            </p-dropdown>
          </div>
          <div class="column is-6 form-container">
            <span class="label">Nombre</span>
            <input
              class="search-input"
              type="text"
              pInputText
              formControlName="name"
              placeholder="Nombre del socio"
              readonly
            />
          </div>
          <div class="column is-6 form-container">
            <span class="label">NIF</span>
            <input
              class="search-input"
              type="text"
              pInputText
              formControlName="documentNumber"
              placeholder="NIF"
              [readonly]="store.clientHasNif()"
            />
            @if (!store.socioForm.get('documentNumber')?.value?.trim()) {
              <small class="help is-danger" data-testid="socio-nif-error">
                El NIF es obligatorio para guardar al socio. Si el cliente no lo tiene, introdúcelo aquí.
              </small>
            }
          </div>
          <div class="column is-6 form-container">
            <span class="label">Domicilio</span>
            <input
              class="search-input"
              type="text"
              pInputText
              formControlName="address"
              placeholder="Domicilio"
            />
          </div>
          <div class="column is-6 form-container">
            <span class="label">Nombre Apellidos/Razón Social representante</span>
            <div class="columns is-mobile" style="margin: 0; gap: 0.5rem; align-items: center;">
              <div class="column" style="padding: 0;">
                <p-dropdown
                  [options]="store.representativeOptions()"
                  optionLabel="name"
                  optionValue="id"
                  class="search-input"
                  formControlName="representativeId"
                  placeholder="Seleccionar representante"
                  [emptyFilterMessage]="'No se encontraron resultados'"
                  appendTo="body"
                ></p-dropdown>
              </div>
              <div class="column is-narrow" style="padding: 0;">
                <button type="button" class="button add-button" (click)="store.addRepresentative()">Añadir</button>
              </div>
            </div>
          </div>
          <div class="column is-6 form-container">
            <span class="label">NIF Representante</span>
            <input
              class="search-input"
              type="text"
              pInputText
              formControlName="representativeNif"
              placeholder="NIF Representante"
              readonly
            />
          </div>

          @if (store.representatives().length > 0) {
            <div class="column is-12">
              <table class="styled-table" style="margin-top: 0.5rem;">
                <thead>
                  <tr>
                    <th>Representante</th>
                    <th>NIF</th>
                    <th class="icon-cell">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  @for (rep of store.representatives(); let i = $index; track rep.id) {
                    <tr>
                      <td>{{ rep.name }}</td>
                      <td>{{ rep.nif || '-' }}</td>
                      <td class="icon-cell">
                        <a class="close-button" (click)="store.removeRepresentative(i, deferPersistence())" title="Eliminar">
                          <fa-icon [icon]="faTrash"></fa-icon>
                        </a>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          }

          <div class="column is-12">
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1rem;">
              <h5 class="section-title" style="margin-bottom: 0;">Acciones Totales</h5>
              <button type="button" class="button add-button" (click)="store.openNumeracionModalNew()">Añadir Numeración</button>
            </div>
          </div>

          @if (store.shareNumberings().length > 0) {
            <div class="column is-12">
              <table class="styled-table grouped-shares-table">
                <thead>
                  <tr>
                    <th>Serie</th>
                    <th class="numeric-cell">Nº Acciones</th>
                    <th class="numeric-cell">Numeración</th>
                    <th class="numeric-cell">Número total</th>
                    <th>Título</th>
                    <th class="numeric-cell">% Titularidad</th>
                    <th class="numeric-cell">Nº Acc. Ajustada</th>
                    <th class="numeric-cell">VN (€)</th>
                    <th class="icon-cell"></th>
                  </tr>
                </thead>
                <tbody
                  (mouseleave)="onGroupedSharesTableBodyLeave()"
                  (mouseover)="onGroupedSharesTableMouseOver($event)"
                >
                  @for (group of groupedShareNumberings(); track group.groupId; let gi = $index) {
                      @for (row of group.rows; track row.globalIndex; let isFirst = $first) {
                        <tr
                          class="grouped-shares-data-row"
                          [attr.data-share-group-id]="group.groupId"
                          [class.grouped-shares-row-hovered]="hoveredShareGroupId() === group.groupId"
                        >
                          @if (isFirst) {
                            <td [attr.rowspan]="group.rows.length + 1">{{ group.seriesName }}</td>
                            <td class="numeric-cell" [attr.rowspan]="group.rows.length + 1">{{ formatShareAmount(group.partnerSharesInSeries) }}</td>
                          }
                          <td class="numeric-cell">{{ formatShareAmount(row.sharesNumberFrom) }} - {{ formatShareAmount(row.sharesNumberTo) }}</td>
                          <td class="numeric-cell">{{ formatShareAmount(row.sharesCount) }}</td>
                          <td>{{ tituloLabel(row.titulo) }}</td>
                          <td class="numeric-cell">{{ formatPct4(row.ownershipPercentage) }}</td>
                          <td class="numeric-cell">{{ formatAdjusted(row.adjustedShares) }}</td>
                          <td class="numeric-cell">{{ row.vnEur != null ? formatEuro(row.vnEur) : '' }}</td>
                          @if (isFirst) {
                            <td
                              class="icon-cell"
                              [attr.rowspan]="group.rows.length + 1"
                              style="vertical-align: middle;"
                            >
                              <div class="table-action-buttons">
                                <a
                                  class="edit-button"
                                  (click)="openNumeracionModalForGroup(group)"
                                  title="Editar numeración de esta serie"
                                >
                                  <fa-icon [icon]="faEdit"></fa-icon>
                                </a>
                                <a
                                  class="close-button"
                                  (click)="removeSeriesGroup(group, $event)"
                                  title="Eliminar esta serie"
                                >
                                  <fa-icon [icon]="faTrash"></fa-icon>
                                </a>
                              </div>
                            </td>
                          }
                        </tr>
                      }
                      <tr
                        class="grouped-shares-subtotal-row"
                        [attr.data-share-group-id]="group.groupId"
                        [class.grouped-shares-row-hovered]="hoveredShareGroupId() === group.groupId"
                      >
                        <td colspan="4" class="subtotal-label"></td>
                        <td class="numeric-cell"><strong>{{ formatAdjusted(group.subtotalAdjusted) }}</strong></td>
                        <td class="numeric-cell"><strong>{{ formatEuro(group.subtotalVn) }}</strong></td>
                      </tr>
                  }
                </tbody>
              </table>

              <div class="totals-and-validation-container socios-participation-totals" style="margin-top: 0.75rem;">
                @for (t of seriesTotals(); track t.seriesName) {
                  <div class="validation-box success">
                    <div class="validation-label">TOTAL {{ t.seriesName }}</div>
                    <div class="validation-value">
                      <strong>{{ t.fractionLabel }}</strong>
                      <span class="percent-value"> = {{ t.percentLabel }}</span>
                    </div>
                  </div>
                }
                <div class="validation-box secondary modal-total-acciones-ajustadas" style="flex-direction: column; align-items: flex-start;">
                  <div class="validation-label">TOTAL ACCIONES AJUSTADAS</div>
                  <div class="validation-value" style="align-self: flex-end;">
                    <strong>{{ formatModalTotalAccionesAjustadas(modalTotalAccionesAjustadas()) }}</strong>
                  </div>
                </div>
              </div>
            </div>
          }

        <div class="column is-12">
          <h5 class="section-title">Socio Trabajador</h5>
        </div>
        <div class="column is-12">
          <div class="field">
            <label class="checkbox">
              <p-checkbox
                formControlName="isWorkerPartner"
                [binary]="true"
              ></p-checkbox>
              <span class="checkbox-label">Socio Trabajador</span>
            </label>
          </div>
        </div>

        @if (store.socioForm.get('isWorkerPartner')?.value) {
          <div class="column is-6 form-container">
            <span class="label">Régimen de la Seguridad Social</span>
            <input
              class="search-input"
              type="text"
              pInputText
              formControlName="socialSecurityRegime"
              placeholder="Ej: Régimen General"
            />
          </div>

          <div class="column is-6 form-container">
            <span class="label">Encuadramiento</span>
            <p-dropdown
              [options]="[
                { label: 'Régimen General', value: 'general' },
                { label: 'Régimen Especial Autónomos', value: 'autonomos' }
              ]"
              optionLabel="label"
              optionValue="value"
              placeholder="Seleccionar encuadramiento"
              formControlName="classification"
            >
            </p-dropdown>
          </div>

          <div class="column is-6 form-container">
            <span class="label">Autónomos a Cargo de</span>
            <p-dropdown
              [options]="[
                { label: 'Empresa', value: 'empresa' },
                { label: 'Persona', value: 'persona' }
              ]"
              optionLabel="label"
              optionValue="value"
              placeholder="Seleccionar"
              formControlName="selfEmployedChargedTo"
            >
            </p-dropdown>
          </div>

          @if (store.socioForm.get('selfEmployedChargedTo')?.value) {
            <div class="column is-6 form-container">
              <span class="label">{{ store.socioForm.get('selfEmployedChargedTo')?.value === 'empresa' ? 'Empresa' : 'Persona' }}</span>
              <input
                class="search-input"
                type="text"
                pInputText
                formControlName="selfEmployedChargedName"
                [placeholder]="store.socioForm.get('selfEmployedChargedTo')?.value === 'empresa' ? 'Nombre empresa' : 'Nombre persona'"
              />
            </div>
          }

          <div class="column is-6 form-container">
            <span class="label">IBAN</span>
            <p-dropdown
              [options]="store.bankAccounts()"
              optionLabel="iban"
              optionValue="id"
              appendTo="body"
              placeholder="Seleccionar cuenta bancaria"
              formControlName="bankAccount"
              [emptyMessage]="'No hay cuentas disponibles'"
            >
              <ng-template let-option pTemplate="item">
                {{ option.iban | ibanFormat }}
              </ng-template>
              <ng-template let-option pTemplate="selectedItem">
                {{ option.iban | ibanFormat }}
              </ng-template>
            </p-dropdown>
          </div>

          <div class="column is-6 form-container">
            <span class="label">Rendimiento Neto Mensual</span>
            <p-inputNumber
              [useGrouping]="true"
              locale="es-ES"
              class="search-input"
              formControlName="monthlyNetIncome"
              placeholder="Ej: 2500"
            />
          </div>

          <div class="column is-6 form-container">
            <span class="label">Mutua ACC: Trabajo/EP</span>
            <input
              class="search-input"
              type="text"
              pInputText
              formControlName="mutualAccidents"
              placeholder="Código mutua"
            />
          </div>

          <div class="column is-6 form-container">
            <span class="label">Mutua CC / IT</span>
            <input
              class="search-input"
              type="text"
              pInputText
              formControlName="mutualCommonContingencies"
              placeholder="Código mutua"
            />
          </div>
        }

        <div class="column is-12">
          <h5 class="section-title">Junta General</h5>
        </div>
        <div class="column is-12">
          <div class="field">
            <label class="checkbox">
              <p-checkbox
                formControlName="isGeneralMeetingPresident"
                [binary]="true"
              ></p-checkbox>
              <span class="checkbox-label">Presidente Junta General</span>
            </label>
          </div>
          <div class="field">
            <label class="checkbox">
              <p-checkbox
                formControlName="isGeneralMeetingSecretary"
                [binary]="true"
              ></p-checkbox>
              <span class="checkbox-label">Secretario Junta General</span>
            </label>
          </div>
          <div class="field" style="margin-top: 1rem;">
            <span class="label">Observaciones</span>
            <textarea
              class="search-input observations-field"
              pInputTextarea
              [autoResize]="true"
              formControlName="observations"
              rows="3"
            ></textarea>
          </div>
        </div>
        </div>
      </section>
      <footer class="modal-card-foot buttons-container">
        <button
          class="button cancel-button"
          type="button"
          (click)="store.closeSocioModal()"
        >
          Cancelar
        </button>
        <button
          class="button save-button"
          type="submit"
          data-testid="socio-guardar"
          [disabled]="!store.socioForm.get('documentNumber')?.value?.trim()"
        >Guardar</button>
      </footer>
    </form>
  </div>
</div>

<!-- Numeración Modal -->
<div class="modal" [ngClass]="{ 'is-active': store.isNumeracionModalVisible() }">
  <div class="modal-background" (click)="store.closeNumeracionModal()"></div>
  <div class="modal-card wider-modal">
    <header class="modal-card-head">
      <p class="modal-card-title">Numeración de acciones</p>
      <button class="delete" aria-label="close" (click)="store.closeNumeracionModal()"></button>
    </header>
    <div>
      <section class="modal-card-body">

        @if (capital.hasSeries()) {
          <div class="columns">
            <div class="column is-6 form-container">
              <span class="label">Serie</span>
              <p-dropdown
                [options]="capital.seriesOptions()"
                optionLabel="label"
                optionValue="value"
                placeholder="Seleccionar serie (opcional)"
                appendTo="body"
                [formControl]="store.numeracionSeriesControl"
                [emptyMessage]="'No hay series disponibles'"
              ></p-dropdown>
            </div>
          </div>
        }

        <table class="styled-table numeracion-ranges-table" style="margin-top: 0.5rem;">
          <thead>
            <tr>
              <th class="numeric-cell">Desde</th>
              <th class="numeric-cell">Hasta</th>
              <th class="numeric-cell">Nº Acciones</th>
              <th>Título</th>
              <th class="numeric-cell">% Titularidad</th>
              <th class="icon-cell"></th>
            </tr>
          </thead>
          <tbody>
            @for (rangeCtrl of store.numeracionRangesArray.controls; let i = $index; track i) {
              <tr [formGroup]="asFormGroup(rangeCtrl)">
                <td class="numeric-cell">
                  <p-inputNumber
                    [useGrouping]="true"
                    locale="es-ES"
                    class="search-input range-input"
                    formControlName="sharesNumberFrom"
                    placeholder="Desde"
                  />
                </td>
                <td class="numeric-cell">
                  <p-inputNumber
                    [useGrouping]="true"
                    locale="es-ES"
                    class="search-input range-input"
                    formControlName="sharesNumberTo"
                    placeholder="Hasta"
                  />
                </td>
                <td class="numeric-cell">
                  <p-inputNumber
                    [useGrouping]="true"
                    locale="es-ES"
                    class="search-input range-input"
                    formControlName="sharesCount"
                    placeholder="Nº"
                  />
                </td>
                <td>
                  <p-dropdown
                    [options]="[
                      { label: 'Plena propiedad', value: 'plena_propiedad' },
                      { label: 'Nuda Propiedad', value: 'nuda_propiedad' },
                      { label: 'Usufructo', value: 'usufructo' }
                    ]"
                    optionLabel="label"
                    optionValue="value"
                    placeholder="Título"
                    appendTo="body"
                    formControlName="titulo"
                  ></p-dropdown>
                </td>
                <td class="numeric-cell">
                  <p-inputNumber
                    [useGrouping]="false"
                    locale="es-ES"
                    mode="decimal"
                    [minFractionDigits]="4"
                    [maxFractionDigits]="4"
                    [suffix]="' %'"
                    class="search-input range-input"
                    formControlName="ownershipPercentage"
                  />
                </td>
                <td class="icon-cell">
                  @if (store.numeracionRangesArray.length > 1) {
                    <a class="close-button" (click)="store.removeModalRange(i)" title="Eliminar fila">
                      <fa-icon [icon]="faTrash"></fa-icon>
                    </a>
                  }
                </td>
              </tr>
              @if (rangeCtrl.errors?.['rangeInvalid']) {
                <tr class="range-error-row">
                  <td colspan="6">
                    <div class="form-error-box" style="margin: 0;">
                      <fa-icon [icon]="diamondExclamation" class="form-error-icon"></fa-icon>
                      <span>Fila {{ i + 1 }}: el rango debe ir de menor a mayor.</span>
                    </div>
                  </td>
                </tr>
              }
              @if (rangeCtrl.errors?.['sharesCountMismatch']) {
                <tr class="range-error-row">
                  <td colspan="6">
                    <div class="form-error-box" style="margin: 0;">
                      <fa-icon [icon]="diamondExclamation" class="form-error-icon"></fa-icon>
                      <span>
                        Fila {{ i + 1 }}: el nº de acciones
                        (<strong>{{ formatShareAmount(rangeCtrl.errors['sharesCountMismatch'].actualCount) }}</strong>)
                        no coincide con el rango
                        (<strong>{{ formatShareAmount(rangeCtrl.errors['sharesCountMismatch'].expectedCount) }}</strong>).
                      </span>
                    </div>
                  </td>
                </tr>
              }
            }
          </tbody>
        </table>

        <div style="margin-top: 0.75rem;">
          <button type="button" class="button add-button" (click)="store.addModalRange()">
            + Añadir
          </button>
        </div>

        @if (store.numeracionError()) {
          <div class="form-error-box" style="margin-top: 0.75rem;">
            <fa-icon [icon]="diamondExclamation" class="form-error-icon"></fa-icon>
            <span>{{ store.numeracionError() }}</span>
          </div>
        }

      </section>
      <footer class="modal-card-foot buttons-container">
        <button class="button cancel-button" type="button" (click)="store.closeNumeracionModal()">
          Cancelar
        </button>
        <button
          class="button save-button"
          type="button"
          [disabled]="store.numeracionRangesArray.invalid"
          (click)="saveNumeracion()"
        >
          Guardar
        </button>
      </footer>
    </div>
  </div>
</div>
